import { lazy } from "react";
import ChangeCallingNumber from "../pages/verification/ChangeOrderNumber";
import GenerateGstInvoice from "../pages/invoices/GenerateInvoice";
import AdminInvoices from "../pages/invoices/Invoices";

// Lazy-loaded components
const AuthenticatedComponent = lazy(
  () => import("../components/IsAuthenticated"),
);
const Index = lazy(() => import("../pages/Index"));
const LoginCoverNumber = lazy(() => import("../pages/auth/LoginCoverNumber"));
const LoginAsUser = lazy(() => import("../pages/management/login-as-user"));
const BuyCategory = lazy(() => import("../pages/buy/BuyCategory"));
const BuySubCategory = lazy(() => import("../pages/buy/BuySubCategory"));
const Defaulters = lazy(() => import("../pages/common/Defaulters"));
const BuyItems = lazy(() => import("../pages/buy/BuyItems"));
const BuyEstimate = lazy(() => import("../pages/management/BuyEstimate"));
const RentEstimate = lazy(() => import("../pages/management/rent-estimate"));
const RentItems = lazy(() => import("../pages/rent/RentItems"));
const RentCategory = lazy(() => import("../pages/rent/RentCategory"));
const RentSubCategory = lazy(() => import("../pages/rent/RentSubCategory"));
const RentUpdate = lazy(() => import("../pages/management/rent-update"));
const RentUpdateWithoutPriceChange = lazy(
  () => import("../pages/management/rent-update-without-price-change"),
);
const RentalItemUpdate = lazy(() => import("../pages/rent/RentalItemUpdate"));
const RentalItemOps = lazy(() => import("../pages/rent/RentalItemOps"));
const ErrorComponent = lazy(() => import("../components/Common/Error"));
const WalletCredit = lazy(() => import("../pages/management/wallet-credit"));
const IpWhitelist = lazy(() => import("../pages/management/ip-whitelist"));
const RentItemsManagement = lazy(() => import("../pages/rent/rent-items"));
const CancellationReason = lazy(
  () => import("../pages/cancellation/CancellationReason"),
);
const Inclusion = lazy(() => import("../pages/common/Inclusion"));
const Coupon = lazy(() => import("../pages/common/Coupons"));
const RentalVarients = lazy(() => import("../pages/rent/RentalVarients"));
const FAQ = lazy(() => import("../pages/common/FAQ"));
const BUBAdvanceReceived = lazy(
  () => import("../pages/common/BUBAdvanceReceived"),
);
const TrendingProducts = lazy(() => import("../pages/common/TrendingProducts"));
const Themes = lazy(() => import("../pages/common/Themes"));
const Occasions = lazy(() => import("../pages/common/Occasions"));
const CustomizableItems = lazy(
  () => import("../pages/common/CustomizableItems"),
);
const ProductPictures = lazy(() => import("../pages/common/ProductPictures"));
const Cities = lazy(() => import("../pages/common/Cities"));
const Cashback = lazy(() => import("../pages/common/Cashback"));
const SurgeProduct = lazy(() => import("../pages/surge/SurgeProduct"));
const ExtensionSurge = lazy(() => import("../pages/surge/ExtensionSurge"));
const SurgePrice = lazy(() => import("../pages/surge/SurgeDate"));
const VerifyOrder = lazy(() => import("../pages/verification/VerifyOrder"));
const SeekOrders = lazy(() => import("../pages/verification/SeekOrders"));
const ChangeOrderNumber = lazy(
  () => import("../pages/verification/ChangeOrderNumber"),
);
const UserLookup = lazy(() => import("../pages/verification/UserLookup"));
const SurgeCity = lazy(() => import("../pages/surge/SurgeCity"));
const SeonRule = lazy(() => import("../pages/common/SeonRuleUpdate"));
const ProcessRefund = lazy(() => import("../pages/refund/ProcessRefund"));
const UpdateAddress = lazy(() => import("../pages/common/UpdateAddress"));
const CancelOrder = lazy(() => import("../pages/cancellation/CancelOrder"));
const CustomerCancellationRequest = lazy(
  () => import("../pages/cancellation/CustomerCancellationRequest"),
);
const AdminCancellationRequest = lazy(
  () => import("../pages/cancellation/AdminCancellationRequest"),
);
const AdjustmentUpdate = lazy(() => import("../pages/common/AdjustmentUpdate"));
const RentSuperCategories = lazy(
  () => import("../pages/rent/RentSuperCateogries"),
);
const DefaultTypes = lazy(() => import("../pages/common/DefaulterTypes"));
const RentalItemSubProductsUpdate = lazy(
  () => import("../pages/rent/RentalItemSubProductsUpdate"),
);
const ComboProducts = lazy(() => import("../pages/common/ComboProducts"));
const AdminCancellationRequestRTO = lazy(
  () => import("../pages/cancellation/AdminCancellationRequestRTO"),
);
const CancellationRequestUpdate = lazy(
  () => import("../pages/cancellation/CancellationRequestUpdate"),
);
const CancellationRequestFind = lazy(
  () => import("../pages/cancellation/CancellationRequestFind"),
);
const SendCustomerPrompt = lazy(
  () => import("../pages/management/send-customer-prompt"),
);
const RequestRefund = lazy(() => import("../pages/refund/ManageRefund"));
const NewProcessRefund = lazy(() => import("../pages/refund/NewProcessRefund"));
const WalletRefund = lazy(() => import("../pages/refund/WalletRefund"));
const RefundProposal = lazy(() => import("../pages/refund/RefundProposals"));
const CreateRefundProposal = lazy(
  () => import("../pages/refund/CreateRefundProposal"),
);
const CustomerTickets = lazy(() => import("../pages/tickets/CustomerTickets"));
const Tickets = lazy(() => import("../pages/tickets/CustomerTicketsType"));
const ProductDetails = lazy(() => import("../pages/common/ProductDetails"));
const RefundReason = lazy(() => import("../pages/refund/RefundReasons"));
const IPWhitelistformPage = lazy(
  () => import("../pages/management/IPWhitelistformPage"),
);
const PromotionBanners = lazy(
  () => import("../pages/management/promotion-banners"),
);
const ReturnDetails = lazy(() => import("../pages/return/ReturnDetails"));
const Bikes = lazy(() => import("../pages/bikes/Bikes"));
const BikesCities = lazy(() => import("../pages/bikes/BikeCity"));
const BikesCityHubs = lazy(() => import("../pages/bikes/BikeCityHubs"));
const AssetPartnerProducts = lazy(
  () => import("../pages/assetfunds/AssetPartnerProducts"),
);
const AssetPartnerPurchasedItems = lazy(
  () => import("../pages/assetfunds/AssetPartnerPurchasedItems"),
);
//const BikesPricing = lazy(() => import('../pages/bikes/BikePricing'));
//const ResalePage = lazy(() => import('../pages/resale/ResalePage'));
//const ResaleCategory = lazy(() => import('../pages/resale/ResaleCategory'));
//const ResaleSubcategory = lazy(() => import('../pages/resale/ResaleSubcategory'));
//const ResaleProducts = lazy(() => import('../pages/resale/ResaleProducts'));
//const ResaleInclusions = lazy(() => import('../pages/resale/ResaleInclusions'));
//const ResaleQualityPage = lazy(() => import('../pages/resale/ResaleQuality'));
const TrypalItems = lazy(() => import("../pages/trypal/TrypalItems"));
const TrypalBrands = lazy(() => import("../pages/trypal/TrypalBrands"));
const TrypalInclusions = lazy(() => import("../pages/trypal/TrypalInclusions"));
const BikesItems = lazy(() => import("../pages/bikes/BikesItems"));
const Careers = lazy(() => import("../pages/common/Careers"));
const ResaleCategory = lazy(() => import("../pages/resale-new/ResaleCategory"));
const ResaleSubcategory = lazy(
  () => import("../pages/resale-new/ResaleSubcategory"),
);
const ResaleProducts = lazy(() => import("../pages/resale-new/ResaleProducts"));
const ResaleItems = lazy(() => import("../pages/resale-new/ResaleItems"));
const ResaleFreeInclusions = lazy(
  () => import("../pages/resale-new/ResaleFreeInclusions"),
);
const ResaleInclusions = lazy(
  () => import("../pages/resale-new/ResaleInclusions"),
);
const ResaleQualityTypes = lazy(
  () => import("../pages/resale-new/ResaleQualityTypes"),
);
const ResaleAddons = lazy(() => import("../pages/resale-new/ResaleAddons"));
const ResaleSellCategory = lazy(
  () => import("../pages/resale-sell/ResaleSellCategory"),
);
const ResaleSellSubcategory = lazy(
  () => import("../pages/resale-sell/ResaleSellSubcategory"),
);
const ResaleSellProducts = lazy(
  () => import("../pages/resale-sell/ResaleSellProducts"),
);
const OurTeams = lazy(() => import("../pages/common/OurTeam"));
const Warehouses = lazy(() => import("../pages/common/Warehouses"));

const EwsCategories = lazy(() => import("../pages/ews/EwsCategories"));
const EwsProducts = lazy(() => import("../pages/ews/EwsProducts"));
const EwsProductPrices = lazy(() => import("../pages/ews/EwsProductPrices"));
const EwsOrders = lazy(() => import("../pages/ews/EwsOrders"));
const EwsDetails = lazy(() => import("../pages/ews/EwsDetails"));
const AssetProgramLeadPage = lazy(
  () => import("../pages/common/AssetProgramLead"),
);
const UpdateUser = lazy(() => import("../pages/common/UpdateUser"));
const DecryptData = lazy(() => import("../pages/management/decrypt-data"));
const ManageCommunication = lazy(
  () => import("../pages/management/manage-communication"),
);

// Error pages
const Error404 = lazy(() => import("../pages/error/Error404"));
const Error500 = lazy(() => import("../pages/error/Error500"));
const Error503 = lazy(() => import("../pages/error/Error503"));
const Maintenence = lazy(() => import("../pages/error/Maintenence"));

const errorRoutes = [
  { path: "/error", element: <Error404 />, layout: "blank" },
  { path: "/pages/error404", element: <Error404 />, layout: "blank" },
  { path: "/pages/error500", element: <Error500 />, layout: "blank" },
  { path: "/pages/error503", element: <Error503 />, layout: "blank" },
  { path: "/pages/maintenence", element: <Maintenence />, layout: "blank" },
];

const routes = [
  // Dashboard
  {
    path: "/",
    element: (
      <AuthenticatedComponent allowedRoles={["admin", "user"]}>
        <Index />
      </AuthenticatedComponent>
    ),
  },

  // Authentication
  { path: "/auth/login", element: <LoginCoverNumber />, layout: "blank" },
  { path: "/login-as-user", element: <LoginAsUser /> },

  // Common Pages
  { path: "/cancel-order", element: <CancelOrder /> },
  { path: "/cancellation-reason", element: <CancellationReason /> },
  {
    path: "/customer-cancellation-requests",
    element: <CustomerCancellationRequest />,
  },
  {
    path: "/internal-cancellation-requests",
    element: <AdminCancellationRequest />,
  },
  {
    path: "/rto-internal-cancellation-requests",
    element: <AdminCancellationRequestRTO />,
  },
  {
    path: "/cancellation-requests-update",
    element: <CancellationRequestUpdate />,
  },
  {
    path: "/cancellation-requests-find",
    element: <CancellationRequestFind />,
  },
  { path: "/bub-advance-update", element: <BUBAdvanceReceived /> },
  { path: "/ip-whitelist-form", element: <IPWhitelistformPage /> },
  { path: "/ip-whitelist", element: <IpWhitelist /> },
  { path: "/promotion-banners", element: <PromotionBanners /> },
  {
    path: "/decrypt-data",
    element: (
      <AuthenticatedComponent allowedRoles={["admin"]}>
        <DecryptData />
      </AuthenticatedComponent>
    ),
  },
  { path: "/manage-communication", element: <ManageCommunication /> },
  { path: "/return-details", element: <ReturnDetails /> },
  { path: "/trending-products", element: <TrendingProducts /> },
  { path: "/customizable-items", element: <CustomizableItems /> },
  { path: "/product-pictures", element: <ProductPictures /> },
  { path: "/product-details", element: <ProductDetails /> },
  { path: "/cities", element: <Cities /> },
  { path: "/cashback", element: <Cashback /> },
  { path: "/rental-item-update", element: <RentalItemUpdate /> },
  { path: "/rental-item-ops", element: <RentalItemOps /> },
  { path: "/send-customer-prompt", element: <SendCustomerPrompt /> },
  { path: "/request-refunds", element: <RequestRefund /> },
  { path: "/bikes", element: <Bikes /> },
  { path: "/bikes-cities", element: <BikesCities /> },
  { path: "/bikes-hubs", element: <BikesCityHubs /> },
  //{ path: '/bikes-pricing', element: <BikesPricing /> },
  { path: "/themes", element: <Themes /> },
  { path: "/occasions", element: <Occasions /> },
  { path: "/seon-rules", element: <SeonRule /> },
  { path: "/inclusion", element: <Inclusion /> },
  { path: "/wallet-credit", element: <WalletCredit /> },
  { path: "/surge-product", element: <SurgeProduct /> },
  { path: "/extension-surge", element: <ExtensionSurge /> },
  { path: "/surge-pricing", element: <SurgePrice /> },
  { path: "/rental-varients", element: <RentalVarients /> },
  { path: "/default-types", element: <DefaultTypes /> },
  { path: "/update-customer-type", element: <UpdateUser /> },
  {
    path: "/rental-item-sub-products-update",
    element: <RentalItemSubProductsUpdate />,
  },
  { path: "/coupons", element: <Coupon /> },
  { path: "/adjustment-update", element: <AdjustmentUpdate /> },
  { path: "/process-refunds", element: <ProcessRefund /> },
  { path: "/new-process-refunds", element: <NewProcessRefund /> },
  { path: "/wallet-refund", element: <WalletRefund /> },
  { path: "/refund-proposal", element: <RefundProposal /> },
  { path: "/create-refund-proposal", element: <CreateRefundProposal /> },
  { path: "/refund-reasons", element: <RefundReason /> },
  { path: "/faqs", element: <FAQ /> },
  { path: "/defaulters", element: <Defaulters /> },
  { path: "/update-address", element: <UpdateAddress /> },
  { path: "/customer-tickets", element: <CustomerTickets /> },
  { path: "/assets-program-leads", element: <AssetProgramLeadPage /> },
  { path: "/tickets", element: <Tickets /> },
  { path: "/combo-products", element: <ComboProducts /> },
  { path: "/our-teams", element: <OurTeams /> },
  { path: "/carrers", element: <Careers /> },
  // Buy Routes
  { path: "/buy-items", element: <BuyItems /> },
  { path: "/buy-category", element: <BuyCategory /> },
  { path: "/buy-subcategory", element: <BuySubCategory /> },
  { path: "/buy-estimate", element: <BuyEstimate /> },
  { path: "/surge-city", element: <SurgeCity /> },

  // Rent Routes
  { path: "/rent-estimate", element: <RentEstimate /> },
  { path: "/update-order", element: <RentUpdate /> },
  {
    path: "/update-order-without-change",
    element: <RentUpdateWithoutPriceChange />,
  },
  { path: "/rent-items", element: <RentItems /> },
  { path: "/rent-items-new", element: <RentItemsManagement /> },
  { path: "/rent-category", element: <RentCategory /> },
  { path: "/rent-subcategory", element: <RentSubCategory /> },
  { path: "/rent-supercategory", element: <RentSuperCategories /> },

  // Verification
  { path: "/verify-order", element: <VerifyOrder /> },
  { path: "/verify-order-team", element: <VerifyOrder /> },
  { path: "/seek-orders", element: <SeekOrders /> },
  { path: "/change-calling-number", element: <ChangeOrderNumber /> },
  { path: "/user-lookup", element: <UserLookup /> },

  { path: "/resale-category", element: <ResaleCategory /> },
  { path: "/resale-subcategory", element: <ResaleSubcategory /> },
  { path: "/resale-products", element: <ResaleProducts /> },
  { path: "/resale-items", element: <ResaleItems /> },
  { path: "/resale-inclusions", element: <ResaleInclusions /> },
  { path: "/resale-free-inclusions", element: <ResaleFreeInclusions /> },

  { path: "/resale-addons", element: <ResaleAddons /> },
  { path: "/resale-quality-types", element: <ResaleQualityTypes /> },

  // Resale Sell
  { path: "/resale-sell-category", element: <ResaleSellCategory /> },
  { path: "/resale-sell-subcategory", element: <ResaleSellSubcategory /> },
  { path: "/resale-sell-products", element: <ResaleSellProducts /> },
  //{ path: '/resale-quality-types', element: <ResaleQualityPage /> },
  // Trypal Routes
  { path: "/trypal-items", element: <TrypalItems /> },
  { path: "/trypal-brands", element: <TrypalBrands /> },
  { path: "/trypal-inclusions", element: <TrypalInclusions /> },

  { path: "/generate-invoice", element: <GenerateGstInvoice /> },
  { path: "/zoho-invoices", element: <AdminInvoices /> },
  { path: "/warehouse", element: <Warehouses /> },

  { path: "/asset-partner-products", element: <AssetPartnerProducts /> },
  {
    path: "/asset-partner-purchased-items",
    element: <AssetPartnerPurchasedItems />,
  },

  // EWS Routes
  { path: "/ews-categories", element: <EwsCategories /> },
  { path: "/ews-products", element: <EwsProducts /> },
  { path: "/ews-product-prices", element: <EwsProductPrices /> },
  // { path: "/ews-orders", element: <EwsOrders /> },
  // { path: "/ews-details", element: <EwsDetails /> },
  // Error routes
  ...errorRoutes,

  // Catch-all route
  { path: "*", element: <ErrorComponent />, layout: "blank" },
];

export { routes };
